import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';

import QueueDeck from './QueueDeck.mdx';

# Edit Channel

## <v-icon>mdi-rename-box</v-icon> Channel Details

### Channel Name

This is where you can change your channel name.

### Description

This is where you can change the description for your channel.

## <v-icon>mdi-playlist-play</v-icon> Channel Queues

<QueueDeck />

## <v-icon>mdi-clipboard-list</v-icon> Channel POPs (Proof of Playout)

This is a log of the scenes that played out in this channel.

Channels will only log playouts if they are assigned to a frame.

This only shows the last 100 playout logs.

All logs are permanently stored in the database.

## Delete Channel

To delete this Channel click <ExampleDeleteButton /> a confirmation box will ask you to confirm.

## Save Changes

Click <ExampleSaveButton /> (bottom right) to save the changes, click <ExampleCloseButton /> (top right) to cancel changes.
